import { getUsuariosLimitaciones } from 'api/usuarios/usuariosLimitaciones';
import store from 'store/store';
import { selectUser } from 'store/auth';

const ESTADO_GLOBAL_AUTORIZADO = 4;

/**
 * Resuelve el estado de Firma Electrónica (FEA) / confirmación de Nombramientos
 * para el usuario logueado:
 * - existeConfiguracion: si hay al menos un paso Autorizado configurado para la
 *   entidad (FEA o de confirmación simple) -- sin esto nadie puede actuar, sin
 *   importar quién esté logueado.
 * - puedeFirmar: si el usuario logueado está asignado a alguno de esos pasos.
 * - requiereFea: si el paso del usuario logueado requiere certificado FEA
 *   (true) o es una confirmación simple sin certificado/contraseña (false).
 *   Ver firmar_nombramiento_masivo (nominas/views/nombramiento.py): el mismo
 *   botón "Firmar (FEA)" se usa para ambos casos, solo cambia si pide archivo
 *   y contraseña.
 *
 * Debe reflejar exactamente la misma regla que valida el backend en
 * `firmar_nombramiento_masivo`, para que el botón "Firmar (FEA)" se
 * deshabilite/adapte en el mismo caso en que el backend lo haría.
 *
 * @param {(params: object) => Promise<object[]|{results: object[]}>} getLimitaciones
 *   Función de API que lista los pasos de autorización (ej.
 *   getLimitacionesAutorizacionNombramientos).
 * @returns {Promise<{existeConfiguracion: boolean, puedeFirmar: boolean, requiereFea: boolean}>}
 */
export const obtenerEstadoFirmanteFEA = async (getLimitaciones) => {
  try {
    const existeData = await getLimitaciones({
      estados_globales: ESTADO_GLOBAL_AUTORIZADO,
    });
    const pasosFEA = existeData?.results || existeData || [];
    const existeConfiguracion = pasosFEA.length > 0;

    if (!existeConfiguracion) {
      return { existeConfiguracion: false, puedeFirmar: false, requiereFea: true };
    }

    const currentUserId = selectUser(store.getState())?.id;
    if (!currentUserId) {
      return { existeConfiguracion, puedeFirmar: false, requiereFea: true };
    }

    const uliData = await getUsuariosLimitaciones({ usuario: currentUserId });
    const uli = (uliData.results || uliData || [])[0];
    if (!uli) {
      return { existeConfiguracion, puedeFirmar: false, requiereFea: true };
    }

    const misPasosData = await getLimitaciones({
      usuarios_limitacion_de_informacion: uli.id,
      estados_globales: ESTADO_GLOBAL_AUTORIZADO,
    });
    const misPasosFEA = misPasosData?.results || misPasosData || [];

    return {
      existeConfiguracion,
      puedeFirmar: misPasosFEA.length > 0,
      requiereFea: misPasosFEA.some((p) => p.requiere_firma_electronica),
    };
  } catch (err) {
    return { existeConfiguracion: false, puedeFirmar: false, requiereFea: true };
  }
};

export default obtenerEstadoFirmanteFEA;
